// src/hooks/useLayoutWrapperLogic.jsx
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { initPrintRequestStream, closePrintRequestStream } from "../services/printRequest.service";

export default function useLayoutWrapper() {
  const dispatch = useSelector((state) => state); // can pass dispatch if using react-redux hooks
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = !!token;

  const reduxUserId = useSelector((state) => state.auth.vendorData?.id) || null;
  const [storageUserId, setStorageUserId] = useState(null);

  const [storeId, setStoreId] = useState(null); // optional: storeId from context or redux
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // sessionStorage user
    const raw = sessionStorage.getItem("vendorData");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setStorageUserId(parsed?.id ?? null);
      } catch {
        setStorageUserId(null);
      }
    }
  }, []);

  const userId = reduxUserId ?? storageUserId ?? null;

  useEffect(() => {
    // Simulate fetching storeId or get it from context
    if (userId) {
      // For demo, assume storeId = userId (or fetch real storeId)
      setStoreId(userId);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (isAuthenticated && storeId) {
      initPrintRequestStream(storeId, dispatch);
    }
    return () => closePrintRequestStream();
  }, [isAuthenticated, storeId, dispatch]);

  return { isAuthenticated, userId, storeId, loading };
}
